import { createStore } from 'vuex';

import app from './modules/app';
import user from './modules/user';

const store = createStore({
    modules: {
        app: app,
        user: user,
    },
    getters: {
        requestLoading: state => state.app.requestLoading,
        backendMsgType: state => state.app.backendMsgType,
        backendMsg: state => state.app.backendMsg,
        size: state => state.app.size,

        company: state => state.app.company,
        activeNav: state => state.app.activeNav,
        
        token: state => state.user.token,
        userInfo: state => state.user.userInfo,
    },
})

export default store